import { render, staticRenderFns } from "./angariacao.vue?vue&type=template&id=272511de&scoped=true"
import script from "./angariacao.vue?vue&type=script&lang=js"
export * from "./angariacao.vue?vue&type=script&lang=js"
import style0 from "./angariacao.vue?vue&type=style&index=0&id=272511de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272511de",
  null
  
)

export default component.exports